let showToastFunction = null; // Store the function globally

// Function to set the toast function from the provider
export const setToastFunction = (fn) => {
  showToastFunction = fn;
};

// Function to show the toast message
export const showToastMessage = (message, variant = 'success') => {
  if (showToastFunction) {
    showToastFunction(message, variant);
  } else {
    console.warn("Toast function is not initialized.");
  }
};